import {
  Button as ChakraButton,
  Flex,
  Input as ChakraInput,
  Text,
  Image,
} from '@chakra-ui/react';
import LnkNavigate from '../utility/templates/navigateLink';
import {
  Button,
  TextInput,
  HeadingText,
  BodyText,
  Link,
} from '@spotoninc/nexus-react';
import { FormControl, FormLabel } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useFeatureFlagFromContext } from '../../launchdarkly';
import birdLogo from '../../media/images/Logo.png';
import EmailIcon from '../../media/images/EmailIcon.svg';
import bg from '../../media/images/background.png';
import ReCAPTCHA from 'react-google-recaptcha';
import MiniFormCard from '../utility/templates/miniFormCard';
import apiEndpoint from '../config/data';
import { isReCaptchaRequired } from '../../utils/recaptchaUtils';

const ForgotPassword = ({ onViewChange }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [reCapPass, setReCapPass] = useState(false);

  // Get the showReskin feature flag
  const showReskin = useFeatureFlagFromContext('showReskin', false);
  useEffect(() => {
    window.scrollTo(0, 0);

    // Auto-pass ReCAPTCHA check when not on production or QA environments
    if (!isReCaptchaRequired()) {
      setReCapPass(true);
    }
  }, []);

  // Create a reference to the email input for both versions
  const emailInputRef = React.useRef(null);

  // Update the resetCheck function to use the correct email input
  const resetCheck = () => {
    setButtonLoader(true);
    var flag = false;
    const emailRegex = /^[^\s@]+(?:\+[^\s@]+)?@[^\s@]+\.[^\s@]+$/;

    // Get email value based on which version is rendered
    const emailValue = showReskin
      ? emailInputRef.current?.value || ''
      : document.getElementById('email')?.value || '';

    if (emailRegex.test(emailValue) && emailValue !== '') {
      flag = true;
    } else {
      if (!emailRegex.test(emailValue)) {
        alert('Please enter valid email id.');
      }
      flag = false;
    }

    if (flag) {
      // Check if ReCAPTCHA is required for this hostname
      const shouldCheckReCaptcha = isReCaptchaRequired();

      if (!shouldCheckReCaptcha || reCapPass) {
        var formData = new FormData();
        formData.append('email', emailValue);
        formData.append('email_type', 'password_reset');
        if (showReskin) {
          formData.append('brand', 'profit_assist');
        }
        fetch(apiEndpoint + '/api/miniReg/', {
          method: 'POST',
          body: formData,
        })
          .then(data => data.json())
          .then(data => {
            setButtonLoader(false);
            alert(data['status']);
            // If onViewChange exists, use it to navigate back to login
            if (onViewChange) {
              onViewChange('login');
            } else {
              // Fallback to direct navigation if not in SplashScreen
              window.open('/', '_self');
            }
          })
          .catch(err => {
            console.error(err);
            setButtonLoader(false);
          });
      } else {
        alert('Please select the ReCaptcha.');
        setButtonLoader(false);
      }
    } else {
      alert('Please Fill all the details.');
      setButtonLoader(false);
    }
  };

  // Update the resetCheck function to use the reference
  const handleResetClick = () => {
    resetCheck();
  };

  if (showReskin) {
    // Render the Nexus version when showReskin is true
    return (
      <Flex
        direction="column"
        align="center"
        gap={4}
        width="100%"
        minW="70%"
        style={{ marginLeft: '2rem', marginRight: '2rem' }}
      >
        <Flex direction="column" align="center" gap={2}>
          <HeadingText variant="heading2" color="neutral.900">
            Forgot Password
          </HeadingText>
          <BodyText variant="body2" color="neutral.600">
            Enter your email to reset your password
          </BodyText>
        </Flex>

        <Flex direction="column" width="auto" minWidth="70%" gap={4}>
          <TextInput
            type="email"
            label="Email"
            placeholder="youremail@domain.com"
            ref={emailInputRef}
            id="nexus-email"
            leadingIcon={() => <Image src={EmailIcon} alt="email" />}
            style={{ width: '100%' }}
          />

          {/* Only show ReCAPTCHA on qa.usestarfish.com or app.usestarfish.com */}
          {isReCaptchaRequired() && (
            <Flex width={'100%'} justifyContent={'left'} mb={4}>
              <ReCAPTCHA
                render="explicit"
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={() => {
                  setReCapPass(true);
                }}
                onError={() => {
                  setReCapPass(false);
                  alert('Please try the ReCaptcha again!');
                }}
                onExpired={() => {
                  setReCapPass(false);
                  alert('Please try the ReCaptcha again!');
                }}
              />
            </Flex>
          )}

          <Button
            variant="primary"
            onClick={handleResetClick}
            isLoading={buttonLoader}
            fullWidth
            className="centered-spinner-button"
          >
            Reset
          </Button>

          <Flex direction="column" gap={2}>
            <BodyText variant="body2" color="neutral.600">
              Not registered yet?{' '}
              <Link
                onClick={() => onViewChange && onViewChange('register')}
                style={{ textDecoration: 'none', cursor: 'pointer' }}
              >
                Create an Account!
              </Link>
            </BodyText>

            <BodyText variant="body2" color="neutral.600">
              Remember your password?{' '}
              <Link
                onClick={() => onViewChange && onViewChange('login')}
                style={{ textDecoration: 'none', cursor: 'pointer' }}
              >
                Back to Login
              </Link>
            </BodyText>
          </Flex>
        </Flex>
      </Flex>
    );
  } else {
    // Render the original version with MiniFormCard when showReskin is false
    return (
      <>
        <MiniFormCard
          header="Forgot Password"
          headerDescription="Enter your email id to reset your password"
          logo={birdLogo}
          bg={bg}
          p={10}
        >
          <FormControl isRequired width={'100%'} mb={4}>
            <FormLabel fontSize={'12'} fontWeight={'bold'}>
              Email
            </FormLabel>
            <ChakraInput
              type="email"
              placeholder="mailId@domain.com"
              width={'100%'}
              id="email"
            />
          </FormControl>
          {/* Only show ReCAPTCHA on qa.usestarfish.com or app.usestarfish.com */}
          {isReCaptchaRequired() && (
            <Flex width={'100%'} justifyContent={'center'} mb={4}>
              <ReCAPTCHA
                render="explicit"
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={() => {
                  setReCapPass(true);
                }}
                onError={() => {
                  setReCapPass(false);
                  alert('Please try the ReCaptcha again!');
                }}
                onExpired={() => {
                  setReCapPass(false);
                  alert('Please try the ReCaptcha again!');
                }}
              />
            </Flex>
          )}
          <Flex
            align={'center'}
            justify={'center'}
            width={'100%'}
            direction={'column'}
          >
            <ChakraButton
              width={'100%'}
              bg={'#faac35'}
              borderBottomRadius={'5'}
              borderTopRadius={'5'}
              textColor={'white'}
              mb={2}
              isLoading={buttonLoader}
              onClick={handleResetClick}
            >
              Reset
            </ChakraButton>
            <Flex width={'100%'} direction={'column'} fontSize={'xs'}>
              <Text fontSize={'xs'} color={'gray.500'}>
                Not registered yet?{' '}
              </Text>
              <LnkNavigate color="blue" link="/register">
                Create an Account!
              </LnkNavigate>
              <Text fontSize={'xs'} color={'gray.500'} mt={2}>
                Remember your password?{' '}
              </Text>
              <LnkNavigate color="blue" link="/login">
                Back to Login
              </LnkNavigate>
            </Flex>
          </Flex>
        </MiniFormCard>
      </>
    );
  }
};

export default ForgotPassword;

//<Flex alignItems={'center'} width={'100%'} pl={'10%'}>
//<Fade>
//  <Card
//    align={'center'}
//    borderRadius={'10'}
//    boxShadow={'2xl'}
//    fontFamily={'DM Sans, sans-serif'}
//    p={'9vH'}
//    flex={1}
//    zIndex={200}
//  >
//    <CardBody justifyContent={'space-between'} width={400}>
//      <Flex
//        direction={'column'}
//        textAlign={'left'}
//        width={'100%'}
//        mb={4}
//        align={'center'}
//      >
//        <Image src={birdLogo} height={'auto'} width={100} />
//        <Flex textAlign={'left'} width={'100%'} direction={'column'}>
//          <Heading fontSize={'2xl'} mb={1}>
//            Forgot Password
//          </Heading>
//          <Text fontSize={10} color={'gray.500'}>
//            Enter your email to reset your password!
//          </Text>
//        </Flex>
//      </Flex>
//      <FormControl isRequired width={'100%'} mb={4}>
//        <FormLabel fontSize={'12'} fontWeight={'bold'}>
//          Email
//        </FormLabel>
//        <Input
//          type="email"
//          placeholder="mailId@domain.com"
//          width={'100%'}
//        />
//      </FormControl>
//
//      {/*<ReCAPTCHA render="explicit" sitekey="your_site_key" />*/}
//      <Flex
//        align={'center'}
//        justify={'center'}
//        width={'100%'}
//        direction={'column'}
//      >
//        <Button
//          width={'100%'}
//          bg={'#3311db'}
//          borderBottomRadius={'5'}
//          borderTopRadius={'5'}
//          textColor={'white'}
//          mb={2}
//        >
//          Reset
//        </Button>
//        <Flex width={'100%'} textAlign={'left'}>
//          <Text fontSize={'xs'} color={'gray.500'}>
//            Not registered yet?{' '}
//            <Link color="blue">Create an Account!</Link>
//          </Text>
//        </Flex>
//      </Flex>
//    </CardBody>
//  </Card>
//</Fade>
//
//<Image src={bg} flex={2}></Image>
//</Flex>
